import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useReveal from './hooks/useReveal';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Marquee from './components/Marquee';
import Chapters from './components/Chapters';
import Timeline from './components/Timeline';
import Coverage from './components/Coverage';
import CalloutForm from './components/CalloutForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import StickyCall from './components/StickyCall';

function Landing() {
  useReveal();
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Marquee />
        <Chapters />
        <Timeline />
        <Coverage />
        <CalloutForm />
        <FAQ />
      </main>
      <Footer />
      <StickyCall />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
